// Libs
import React from "react";

// Components
import ModalWrapper from "../../../components/_Shared/ModalWrapper";

// Icons
import chartIcon from "../../../assets/chart-small-icon.svg";

// Style
import "./StoreBuilderSuccessModal.css";

const StoreBuilderSuccessModal = () => {
  return (
    <ModalWrapper
      onHide={() => window.location.replace("/search")}
      className="StoreBuilderSuccessModal__container"
      backdropClassName="StoreBuilderSuccessModal__backdrop"
    >
      <ModalWrapper.Header>
        <div className="StoreBuilderSuccessModal__title-container">
          <img src={chartIcon} alt="chart" />
          <div className="StoreBuilderSuccessModal__title">
            Woo-hoo! You're all set to become an online entrepreneur
            <span>
              Keep an eye on your inbox and we'll email you your customized
              store in 48 hours
            </span>
          </div>
        </div>
      </ModalWrapper.Header>
    </ModalWrapper>
  );
};

export default StoreBuilderSuccessModal;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/modalConductor/StoreBuilderSuccessModal.js